import * as React from "react";
import { RightDrawerDocumentName } from "@/components/feature/layout/right-sidebar/components/documentName";
import { PDFViewer } from "@/components/feature/pdf/pdfViewer";
import { ExcelViewer } from "@/components/feature/excel/excelViewer";
import { useCurrentPdf } from "@/modules/chat/hooks/useCurrentPdf";
import type { BusinessReportOutcomeFsEntry } from "@/modules/snapshots/businessReports.types";
import { getActiveSourceCitation, isSpreadsheetSource } from "@/modules/snapshots/grid/sidebar/sourceDocument";

interface Props {
  fsEntry: BusinessReportOutcomeFsEntry | null;
}

export const GridSidebarSourceViewer: React.FC<Props> = ({ fsEntry }) => {
  const { currentCitation } = useCurrentPdf();
  const activeCitation = getActiveSourceCitation(currentCitation, fsEntry?.id);
  const isSpreadsheet = isSpreadsheetSource({
    contentType: activeCitation?.sourceDocumentContentType ?? fsEntry?.content_type,
    documentName: fsEntry?.document_name,
  });

  return (
    <div className="flex min-h-0 flex-1 flex-col overflow-hidden">
      <div className="shrink-0">
        <RightDrawerDocumentName />
      </div>
      <div className="flex min-h-0 flex-1 flex-col overflow-hidden">
        {isSpreadsheet ? (
          <ExcelViewer citationHighlight={activeCitation} />
        ) : (
          <PDFViewer citationHighlight={activeCitation} />
        )}
      </div>
    </div>
  );
};
